<nz-select
  nzSize="small"
  nzShowSearch
  class="field-select"
  [nzMode]="multiple() ? 'multiple' : 'default'"
  [nzAllowClear]="allowClear()"
  [nzMaxTagCount]="maxTagCount()"
  [nzPlaceHolder]="placeholder()"
  [nzDropdownMatchSelectWidth]="false"
  [nzFilterOption]="filterOption"
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
>
  @for (group of groups(); track group.title) {
    @if (group.title) {
      <nz-option-group [nzLabel]="group.title">
        @for (opt of group.options; track opt.value) {
          <nz-option nzCustomContent [nzValue]="opt.value" [nzLabel]="opt.label">
          <div class="opt">
            <span class="opt-name">{{ opt.label }}</span>
            @if (opt.bytes) {
              <span class="opt-bytes">bytes {{ byteLabel(opt.bytes) }}</span>
            }
          </div>
          @if (opt.description) {
            <div class="opt-desc">{{ opt.description }}</div>
          }
        </nz-option>
        }
      </nz-option-group>
    } @else {
      @for (opt of group.options; track opt.value) {
        <nz-option nzCustomContent [nzValue]="opt.value" [nzLabel]="opt.label">
        <div class="opt">
          <span class="opt-name">{{ opt.label }}</span>
          @if (opt.bytes) {
            <span class="opt-bytes">bytes {{ byteLabel(opt.bytes) }}</span>
          }
        </div>
        @if (opt.description) {
          <div class="opt-desc">{{ opt.description }}</div>
        }
      </nz-option>
      }
    }
  }
</nz-select>
